(() => {
  if (window.__YIZCHO_HOUSE03_MOBILE_ROOFTOP_V01_STANDALONE__) return;

  const controllerUrl = document.currentScript?.src;
  if (controllerUrl && !document.querySelector('link[data-house03-mobile-rooftop-style]')) {
    const style = document.createElement("link");
    style.rel = "stylesheet";
    style.dataset.house03MobileRooftopStyle = "v01";
    style.href = new URL("yizcho-house-03-mobile-rooftop-v01.css", controllerUrl).href;
    document.head.append(style);
  }

  const VIDEO_URL = "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-house-03-black-white-cat-house-mobile-v03.mp4?v=1786710294";
  const POSTER_URL = "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-house-03-black-white-cat-house-mobile-final-v03.webp?v=1786710297";
  const SOURCE_WIDTH = 720;
  const SOURCE_HEIGHT = 1280;
  const WINDOW_X = 0.205;
  const WINDOW_Y = 0.36;
  const CAT_REPLAY_CENTER_X = 0.21;
  const CAT_REPLAY_CENTER_Y = 0.205;
  const CAT_REPLAY_WIDTH = 0.24;
  const CAT_REPLAY_HEIGHT = 0.17;
  const body = document.body;
  const layer = document.querySelector("#closeup-layer");
  const closeupImage = document.querySelector("#closeup-image");
  const video = document.querySelector("#exterior-scene-video");
  const roomEntry = document.querySelector("#room-entry");
  const roomEntryHint = document.querySelector("#room-entry-hint");
  const roomEntryLabel = document.querySelector("#room-entry-label");
  if (!body || !layer || !closeupImage || !video || !roomEntry) {
    if (
      document.readyState === "loading"
      && controllerUrl
      && !window.__YIZCHO_HOUSE03_MOBILE_ROOFTOP_V01_WAITING__
    ) {
      window.__YIZCHO_HOUSE03_MOBILE_ROOFTOP_V01_WAITING__ = true;
      document.addEventListener("DOMContentLoaded", () => {
        delete window.__YIZCHO_HOUSE03_MOBILE_ROOFTOP_V01_WAITING__;
        const retry = document.createElement("script");
        retry.src = controllerUrl;
        document.head.append(retry);
      }, { once: true });
    }
    return;
  }
  window.__YIZCHO_HOUSE03_MOBILE_ROOFTOP_V01_STANDALONE__ = true;

  const replay = document.querySelector("#exterior-scene-replay") || (() => {
    const button = document.createElement("button");
    button.className = "exterior-scene-replay";
    button.id = "exterior-scene-replay";
    button.type = "button";
    button.hidden = true;
    layer.append(button);
    return button;
  })();
  replay.setAttribute("aria-label", "Replay the black-and-white cat's run and rooftop leap with music");
  replay.disabled = true;

  let selected = false;
  let roomWasOpen = false;
  let activationToken = 0;
  let fallbackTimer = 0;
  let restoreTimer = 0;
  let selectionClearTimer = 0;

  const isMobile = () => window.innerWidth < 760;

  const positionWindowEntry = () => {
    const rect = layer.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const renderedHeight = rect.height;
    const renderedWidth = Math.max(rect.width, SOURCE_WIDTH * (renderedHeight / SOURCE_HEIGHT));
    const renderedLeft = (rect.width - renderedWidth) * 0.5;
    const x = renderedLeft + renderedWidth * WINDOW_X;
    const y = renderedHeight * WINDOW_Y;
    layer.style.setProperty("--room-entry-x", `${(x / rect.width) * 100}%`);
    layer.style.setProperty("--room-entry-y", `${(y / rect.height) * 100}%`);
  };

  const positionCatReplay = () => {
    const rect = layer.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const renderedHeight = rect.height;
    const renderedWidth = Math.max(rect.width, SOURCE_WIDTH * (renderedHeight / SOURCE_HEIGHT));
    const renderedLeft = (rect.width - renderedWidth) * 0.5;
    const x = renderedLeft + renderedWidth * CAT_REPLAY_CENTER_X;
    const y = renderedHeight * CAT_REPLAY_CENTER_Y;
    layer.style.setProperty("--exterior-scene-replay-x", `${x}px`);
    layer.style.setProperty("--exterior-scene-replay-y", `${y}px`);
    layer.style.setProperty(
      "--exterior-scene-replay-width",
      `${Math.max(72, renderedWidth * CAT_REPLAY_WIDTH)}px`,
    );
    layer.style.setProperty(
      "--exterior-scene-replay-height",
      `${Math.max(96, renderedHeight * CAT_REPLAY_HEIGHT)}px`,
    );
  };

  const hideCatReplay = () => {
    replay.hidden = true;
    replay.disabled = true;
  };

  const showCatReplay = () => {
    positionCatReplay();
    replay.hidden = false;
    replay.disabled = false;
  };

  const exposeWindowEntry = () => {
    if (!selected || !isMobile() || body.classList.contains("has-room")) return;
    body.classList.add("has-house03-mobile-video", "house03-video-ended");
    body.classList.add("has-exterior-scene-video");
    layer.classList.add("has-exterior-scene-video", "is-exterior-scene-ready", "has-room-entry");
    layer.classList.remove("is-exterior-scene-playing");
    positionWindowEntry();
    showCatReplay();
    roomEntry.hidden = false;
    roomEntry.disabled = false;
    roomEntry.dataset.entryType = "window";
    roomEntry.setAttribute("aria-label", "Tap the second-floor window to enter the Cat Motion Album");
    if (roomEntryHint) roomEntryHint.textContent = "TAP THE SECOND-FLOOR WINDOW";
    if (roomEntryLabel) roomEntryLabel.textContent = "Enter the Cat Motion Album";
  };

  const holdFinalFrame = () => {
    if (!Number.isFinite(video.duration) || video.duration <= 0) {
      exposeWindowEntry();
      return;
    }
    try {
      video.currentTime = Math.max(0, video.duration - 0.01);
    } catch (_) {
      // The matching final-frame poster remains visible if WebKit refuses a seek.
    }
    exposeWindowEntry();
  };

  const clearHouse03 = () => {
    activationToken += 1;
    selected = false;
    roomWasOpen = false;
    window.clearTimeout(fallbackTimer);
    window.clearTimeout(restoreTimer);
    window.clearTimeout(selectionClearTimer);
    hideCatReplay();
    body.classList.remove("has-house03-mobile-video", "house03-video-ended", "has-exterior-scene-video");
    layer.classList.remove("has-exterior-scene-video", "is-exterior-scene-ready", "is-exterior-scene-playing");
    closeupImage.classList.remove("is-exterior-scene-poster");
    if (video.dataset.sceneHouse === "HOUSE-03") {
      video.pause();
      video.defaultMuted = true;
      video.muted = true;
      video.setAttribute("muted", "");
      video.hidden = true;
      video.removeAttribute("src");
      video.removeAttribute("poster");
      delete video.dataset.sceneHouse;
      video.load();
    }
  };

  const prepareVideo = () => {
    video.hidden = false;
    video.loop = false;
    video.playsInline = true;
    video.dataset.sceneHouse = "HOUSE-03";
    if (video.getAttribute("src") !== VIDEO_URL) {
      video.src = VIDEO_URL;
      video.poster = POSTER_URL;
      video.load();
    }
  };

  const playFromStart = (token, { withSound }) => {
    if (token !== activationToken || !selected || !isMobile()) return;
    window.clearTimeout(fallbackTimer);
    body.classList.add("has-house03-mobile-video", "has-exterior-scene-video");
    body.classList.remove("house03-video-ended");
    layer.classList.add("has-exterior-scene-video", "is-exterior-scene-playing");
    layer.classList.remove("has-room-entry");
    roomEntry.hidden = true;
    roomEntry.disabled = true;
    hideCatReplay();
    prepareVideo();
    video.pause();
    try {
      video.currentTime = 0;
    } catch (_) {
      // loadedmetadata will make the zero seek effective before the first frame.
    }
    video.defaultMuted = !withSound;
    video.muted = !withSound;
    video.toggleAttribute("muted", !withSound);
    const playback = video.play();
    playback?.catch(() => {
      if (token !== activationToken || !selected) return;
      if (withSound) {
        // Keep visual autoplay available if a browser rejects audible playback.
        // The user's direct cat replay tap will still retry the music path.
        video.defaultMuted = true;
        video.muted = true;
        video.setAttribute("muted", "");
        video.play().catch(() => holdFinalFrame());
        return;
      }
      holdFinalFrame();
    });
    fallbackTimer = window.setTimeout(() => {
      if (token === activationToken && selected && !body.classList.contains("house03-video-ended") && video.paused) {
        holdFinalFrame();
      }
    }, 2400);
  };

  const activate = (token, attempt = 0) => {
    if (token !== activationToken || !selected || !isMobile()) return;
    if (!body.classList.contains("has-closeup") || !layer.classList.contains("is-active")) {
      if (attempt < 180) window.requestAnimationFrame(() => activate(token, attempt + 1));
      return;
    }

    window.clearTimeout(fallbackTimer);
    body.classList.add("has-house03-mobile-video", "has-exterior-scene-video");
    body.classList.remove("house03-video-ended");
    layer.classList.add("has-exterior-scene-video", "is-exterior-scene-playing");
    layer.classList.remove("is-exterior-scene-ready", "has-room-entry");
    roomEntry.hidden = true;
    roomEntry.disabled = true;
    hideCatReplay();
    closeupImage.classList.add("is-exterior-scene-poster");
    closeupImage.src = POSTER_URL;
    closeupImage.alt = "The final house frame with the black-and-white cat on the roof and the second-floor window available to enter";

    prepareVideo();
    if (video.paused || video.ended) {
      playFromStart(token, { withSound: true });
    } else {
      video.defaultMuted = false;
      video.muted = false;
      video.removeAttribute("muted");
      layer.classList.add("is-exterior-scene-ready");
    }
  };

  const selectHouse03 = () => {
    // Mobile HOUSE-03 now opens its album directly; do not start or arm exterior media.
    if (isMobile()) { clearHouse03(); return; }
    if (!isMobile()) {
      clearHouse03();
      return;
    }
    selected = true;
    roomWasOpen = false;
    const token = ++activationToken;
    body.classList.add("has-house03-mobile-video");
    body.classList.remove("house03-video-ended");
    roomEntry.hidden = true;
    roomEntry.disabled = true;
    hideCatReplay();
    // This call stays inside the trusted HOUSE-03 click so iOS Safari permits
    // the source video's music on the first play.
    playFromStart(token, { withSound: true });
    window.requestAnimationFrame(() => activate(token));
  };

  const replayHouse03 = () => {
    if (!selected || !isMobile() || body.classList.contains("has-room")) return;
    const token = ++activationToken;
    playFromStart(token, { withSound: true });
  };

  video.addEventListener("playing", () => {
    if (!selected || video.dataset.sceneHouse !== "HOUSE-03") return;
    window.clearTimeout(fallbackTimer);
    hideCatReplay();
    body.classList.remove("house03-video-ended");
    layer.classList.add("is-exterior-scene-ready", "is-exterior-scene-playing");
  });

  video.addEventListener("ended", () => {
    if (!selected || video.dataset.sceneHouse !== "HOUSE-03") return;
    holdFinalFrame();
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest?.("#exterior-scene-replay")) {
      event.preventDefault();
      event.stopPropagation();
      replayHouse03();
      return;
    }
    const houseControl = event.target.closest?.("[data-id]");
    if (houseControl) {
      if (houseControl.dataset.id === "HOUSE-03") selectHouse03();
      else clearHouse03();
      return;
    }
    if (event.target.closest?.("#closeup-back, #panel-close")) clearHouse03();
  }, true);

  const observer = new MutationObserver(() => {
    if (!selected || !isMobile()) return;
    if (!body.classList.contains("has-closeup")) {
      // selectHouse() exposes the closeup on the next animation frame. Keep
      // the pending HOUSE-03 selection alive while that normal transition is
      // between has-selection and has-closeup.
      if (!body.classList.contains("has-selection")) {
        window.clearTimeout(selectionClearTimer);
        selectionClearTimer = window.setTimeout(() => {
          if (
            selected
            && !body.classList.contains("has-selection")
            && !body.classList.contains("has-closeup")
          ) clearHouse03();
        }, 320);
      }
      return;
    }
    if (body.classList.contains("has-room")) {
      roomWasOpen = true;
      return;
    }
    if (roomWasOpen) {
      roomWasOpen = false;
      window.clearTimeout(restoreTimer);
      restoreTimer = window.setTimeout(() => {
        if (!selected || body.classList.contains("has-room")) return;
        closeupImage.classList.add("is-exterior-scene-poster");
        closeupImage.src = POSTER_URL;
        video.hidden = false;
        video.poster = POSTER_URL;
        video.dataset.sceneHouse = "HOUSE-03";
        holdFinalFrame();
      }, 980);
    }
  });
  observer.observe(body, { attributes: true, attributeFilter: ["class"] });

  window.addEventListener("resize", () => {
    if (!selected) return;
    if (!isMobile()) clearHouse03();
    else if (body.classList.contains("house03-video-ended")) {
      positionWindowEntry();
      positionCatReplay();
    }
  });
})();
